import type { NextPage } from "next";
import clsx from "clsx";

import { useState } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import LoginCard from "@/components/LoginCard";

import { API_URL } from "@/lib/Auth";

export const URL = process.env.NEXT_PUBLIC_URL;

// type Inputs = {
//   email: string;
//   password: string;
// };
const Forgot: NextPage = () => {
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [busy, setBusy] = useState(false);

  type FormValues = {
    email: string;
    password: string;
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>();

  const onSubmit: SubmitHandler<FormValues> = async (data) => {
    // const onSubmit = async (data: any) => {
    //send data to api
    setBusy(true);
    const res = await fetch(`${API_URL}/auth/forgot`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: data.email,
        url: URL + "/reset/",
      }),
    });

    const json = await res.json();
    setBusy(false);

    if (!res.ok) {
      setError(json.message || json.error);
    } else {
      setSuccess(true);
    }
  };

  return (
    <LoginCard
      title="Forgot password"
      body={
        <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
          <div className="form-control w-full max-w-xs">
            <input
              type="email"
              id="email"
              placeholder="Email address"
              {...register("email", {
                required: true,
              })}
              className="input input-bordered w-full max-w-xs"
            />
            {errors?.email && (
              <p className="text-red-500">{errors.email.message}</p>
            )}
          </div>

          {error && <p className="text-red-500">{error}</p>}

          <div className="form-control w-full max-w-xs">
            {!success && (
              <input
                type="submit"
                className={clsx(
                  "btn btn-primary",
                  busy && "btn-disabled loading",
                )}
              />
            )}
            {success && (
              <p>Password reset email sent, please check your inbox.</p>
            )}
          </div>
        </form>
      }
    />
  );
};

export default Forgot;
